import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBriefcase02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.863 2h.275c.795 0 1.386 0 1.897.136a4 4 0 0 1 2.829 2.829c.082.307.115.643.128 1.035h1.846c.528 0 .982 0 1.357.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356v7.678c0 .527 0 .982-.03 1.356-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.356.031H5.16c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167C1 18.82 1 18.365 1 17.839v-7.677c0-.528 0-.982.03-1.357.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C4.18 6 4.635 6 5.161 6h1.847c.013-.392.046-.728.128-1.035a4 4 0 0 1 2.829-2.829C10.476 2 11.067 2 11.863 2ZM9.01 6c.01-.258.026-.399.058-.518a2 2 0 0 1 1.415-1.414C10.704 4.008 11.005 4 12 4c.995 0 1.296.009 1.518.068a2 2 0 0 1 1.414 1.414c.032.12.049.26.058.518H9.01ZM8 9a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0v-8a1 1 0 0 1 1-1Zm9 1a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0v-8Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgBriefcase02.displayName = 'Briefcase02';
export default SvgBriefcase02;
